import instance from 'utils/axios/instance.axios';
import { DASHBOARD } from './_constant';

export const getProjectProposalsReviewStatus = (params) =>
  instance.get(DASHBOARD.PROJECT_PROPOSALS_REVIEW_STATUS, { params });

export const getProjectStatistics = (params = {}) =>
  instance.get(DASHBOARD.GET_PROJECT_STATISTICS, { params });

export const getProjectStatisticsYear = (params) =>
  instance.get(DASHBOARD.PROJECT_STATISTICS_YEARS, { params });

export const getQuantityStatistics = (params = {}) =>
  instance.get(DASHBOARD.GET_QUANTITY_STATISTICS, { params });

export const getProjectProposalsExpenditures = (params = {}) =>
  instance.get(DASHBOARD.PROJECT_PROPOSALS_EXPENDITURES, { params });
